'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _smartFormShared = require('./smartFormShared');

var _smartFormShared2 = _interopRequireDefault(_smartFormShared);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smartFormReact = {
    registerSmartForms: function registerSmartForms(component, instanceId) {
        var oneSfInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        try {
            if (!(!component.smartFormInitialized && !_smartFormShared2.default.checkSmartForm(true, true, true))) {
                return;
            }

            /* Here is some theory about SmartForm (Sf) registration: It must be always registered with appropriate parameters,
            but it must be done at time, when inputs already exist, what doesn't need to be true in case of using react
            SmartForm is probably designed to work with instances with inputs present on page when page is loaded. 
            This is causing problem in case of multiple instances on page and react. Because all inputs didn't exists
            in DOM at time of page load, smartform.rebindAllForms() must be called, but second calling of this method 
            (triggered by second Sf instance) will destroy already registered settings and callbacks of first instance
            Now description of current implementation: 
            Registered user - non-editable inputs in default, editable inputs of Sf instances are in popups
                 modify main address - react component ContactForm
                 modify secondary (delivery) address - react component AddressForm
             Both have editable inputs and smartform.rebindAllForms() is called, when their popup is open. 
             For that case this method is called with parameter "oneSfInstance = true", 
             what will destroy all settings and callbacks of all Sf instances, but is always recreated. 
            Anonymous user - two sets of editable inputs on page
                 main - react component ContactForm and 
                 delivery address - react component DeliveryAddress,
             main is called first with "oneSfInstance = true", delivery address is called with "oneSfInstance = false",
             what will prevent destroying previous (main) instance */
            if (!window.smartFormRebind || oneSfInstance) {
                smartform.rebindAllForms(function () {
                    console.debug('Rebind all SmartForms');
                    window.smartFormRebind = true;
                    smartFormReact.registerSfEvents(instanceId, component);
                });
                return;
            }
            smartFormReact.registerSfEvents(instanceId, component);
        } catch (e) {
            console.debug(e);
        } finally {
            component.smartFormInitialized = true;
        }
    },
    registerSfEvents: function registerSfEvents(instanceId, component) {
        var smartFormInstance = smartform.getInstance(instanceId);
        if (!smartFormInstance) return;

        _smartFormShared2.default.setBasicSmartFormAttributes(smartFormInstance);

        smartFormInstance.addressControl.setSelectionCallback(function (element, text, fieldType, suggestion) {
            // console.debug can be deleted after some time in production (added 2023/04/04)
            console.debug('Smart Form selection callback, text: ' + text + ', FieldType: ' + fieldType + ', suggestion: ' + suggestion, element);
            var identifier = element.name;
            var resultArray = /[^|.][A-z0-9_-]+$/.exec(identifier);
            if (resultArray.length > 0) {
                identifier = resultArray[0];
            }
            component.changeState(identifier, text);
            element.value = text;
            return true;
        });
        smartFormInstance.emailControl.addValidationCallback(function (validationResult) {
            // console.debug can be deleted after some time in production (added 2023/04/04)
            console.debug('Smart Form validation callback.', validationResult);
            if (!validationResult || !validationResult.result) return;

            component.changeState('emailValidationResult', validationResult.result.resultType);
        });
    }
};

exports.default = smartFormReact;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/smartform/smartFormReact.js
// module id = 409
// module chunks = 0 2